import type { ChipSize } from './types'

/**
 * Высота чипа по size. §21 чип-ответ — 38 (нет точного токена, задокументированное
 * отклонение спеки), §22 чип выбора — 42-44, берём $control-height-s (44).
 */
export const CHIP_HEIGHT: Record<ChipSize, string> = {
  S: '38px',
  M: 'var(--control-height-s)',
}
